import { render, staticRenderFns } from "./WebChatDoctor.vue?vue&type=template&id=f8ec8508"
import script from "./WebChatDoctor.vue?vue&type=script&lang=js"
export * from "./WebChatDoctor.vue?vue&type=script&lang=js"
import style0 from "./WebChatDoctor.vue?vue&type=style&index=0&id=f8ec8508&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports